export const FETCH_COACH = 'FETCH_COACH';
export const RESET_AVAILABLE_DATES = 'RESET_AVAILABLE_DATES';
export const FETCH_AVAILABLE_DATES = 'FETCH_AVAILABLE_DATES';
export const FETCH_AVAILABLE_TIMES = 'FETCH_AVAILABLE_TIMES';



// WEBPACK FOOTER //
// ./src/store/coach/types.js